import { render, staticRenderFns } from "./_SortDetail.vue?vue&type=template&id=7b91beb8&scoped=true&"
import script from "./_SortDetail.vue?vue&type=script&lang=js&"
export * from "./_SortDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b91beb8",
  null
  
)

export default component.exports